import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    len: {
      type: Number,
      default: 7
    },
    codeType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      val: ['宁', '', '', '', '', '', ''],
      activeIndex: this.editable ? 1 : undefined
    };
  },
  mounted: function mounted() {
    // this.activeIndex = 2
  },
  watch: {
    activeIndex: function activeIndex() {
      this.$emit('activeChange', this.activeIndex);
    },
    codeType: function codeType() {
      this.activeIndex = 1;
    },
    value: {
      immediate: true,
      handler: function handler() {
        if (this.val.join('') === this.value) {
          return;
        }
        var val = this.value.split('');
        // if (this.editable) {
        //   this.activeIndex = val.length;
        // }
        while (val.length < this.len) {
          val.push('');
        }
        this.val = val;
      }
    },
    len: function len(val) {
      if (this.len > 7) {
        this.val = ['宁', '', '', '', '', '', '', ''];
      } else {
        this.val = ['宁', '', '', '', '', '', ''];
      }
    },
    val: function val() {
      this.$emit('input', this.val.join(''));
    }
  },
  methods: {
    handleClickItem: function handleClickItem(index) {
      if (!this.editable) {
        return;
      }
      this.activeIndex = index;
    },
    setValue: function setValue(val) {
      // 前一位不能修改
      if (this.activeIndex < 1) {
        return;
      }
      // 禁止删除挂车的’挂‘
      if (this.val[this.activeIndex] === '挂') {
        return;
      }
      this.$set(this.val, this.activeIndex, val);
      if (this.activeIndex < this.len - 1) {
        this.activeIndex += 1;
      }
    },
    del: function del() {
      this.$set(this.val, this.activeIndex, '');
      if (this.activeIndex > 1) {
        this.activeIndex -= 1;
      }
    }
  }
};